import React from 'react';

const IcCalendar = ({ width, height, color }: { width?: string; height?: string; color?: string }) => {
    return (
        <svg width={width || '24'} height={height || '24'} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M7.32397 11.96C7.32397 11.7611 7.48515 11.6 7.68397 11.6H8.98797C9.1868 11.6 9.34797 11.7611 9.34797 11.96V13.264C9.34797 13.4628 9.1868 13.624 8.98797 13.624H7.68397C7.48515 13.624 7.32397 13.4628 7.32397 13.264V11.96Z'
                fill='red'
            />
            <path
                d='M7.32397 15.456C7.32397 15.2572 7.48515 15.096 7.68397 15.096H8.98797C9.1868 15.096 9.34797 15.2572 9.34797 15.456V16.76C9.34797 16.9588 9.1868 17.12 8.98797 17.12H7.68397C7.48515 17.12 7.32397 16.9588 7.32397 16.76V15.456Z'
                fill='#333438'
            />
            <path
                d='M11.5482 11.6C11.3494 11.6 11.1882 11.7612 11.1882 11.96V13.264C11.1882 13.4628 11.3494 13.624 11.5482 13.624H12.8522C13.0511 13.624 13.2122 13.4628 13.2122 13.264V11.96C13.2122 11.7612 13.0511 11.6 12.8522 11.6H11.5482Z'
                fill='#333438'
            />
            <path
                d='M11.1882 15.456C11.1882 15.2572 11.3494 15.096 11.5482 15.096H12.8522C13.0511 15.096 13.2122 15.2572 13.2122 15.456V16.76C13.2122 16.9588 13.0511 17.12 12.8522 17.12H11.5482C11.3494 17.12 11.1882 16.9588 11.1882 16.76V15.456Z'
                fill='#333438'
            />
            <path
                d='M15.4122 11.6C15.2134 11.6 15.0522 11.7612 15.0522 11.96V13.264C15.0522 13.4628 15.2134 13.624 15.4122 13.624H16.7162C16.9151 13.624 17.0762 13.4628 17.0762 13.264V11.96C17.0762 11.7612 16.9151 11.6 16.7162 11.6H15.4122Z'
                fill='#333438'
            />
            <path
                d='M15.0522 15.456C15.0522 15.2572 15.2134 15.096 15.4122 15.096H16.7162C16.9151 15.096 17.0762 15.2572 17.0762 15.456V16.76C17.0762 16.9588 16.9151 17.12 16.7162 17.12H15.4122C15.2134 17.12 15.0522 16.9588 15.0522 16.76V15.456Z'
                fill={color || '#333438'}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.11111 2.59998C8.50876 2.59998 8.83111 2.92233 8.83111 3.31998V4.23993H15.5688V3.31998C15.5688 2.92233 15.8912 2.59998 16.2888 2.59998C16.6865 2.59998 17.0088 2.92233 17.0088 3.31998V4.23993H19.6C20.5941 4.23993 21.4 5.04582 21.4 6.03993V18.9999C21.4 19.994 20.5941 20.7999 19.6 20.7999H4.8C3.80588 20.7999 3 19.994 3 18.9999V6.03993C3 5.04582 3.80589 4.23993 4.8 4.23993H7.39111V3.31998C7.39111 2.92233 7.71347 2.59998 8.11111 2.59998ZM19.6 5.67993H4.8C4.60118 5.67993 4.44 5.84111 4.44 6.03993V8.3244H19.96V6.03993C19.96 5.8411 19.7988 5.67993 19.6 5.67993ZM19.96 9.7644H4.44V18.9999C4.44 19.1988 4.60118 19.3599 4.8 19.3599H19.6C19.7988 19.3599 19.96 19.1988 19.96 18.9999V9.7644Z'
                fill='#333438'
            />
            <path d='M4.8 5.67993H19.6C19.7988 5.67993 19.96 5.8411 19.96 6.03993V8.3244H4.44V6.03993C4.44 5.84111 4.60118 5.67993 4.8 5.67993Z' fill='none' />
        </svg>
    );
};

export default IcCalendar;
